
import React from "react";
import { AdminSidebar } from "./AdminSidebar";
import IntercomChat from "../IntercomChat";
import { useIsMobile } from "@/hooks/use-mobile";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout = ({ children }: AdminLayoutProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="flex h-screen w-full bg-[#0F172A] text-white bg-radial-gradient">
      <AdminSidebar />
      <div className="flex-1 overflow-auto flex flex-col">
        <div className="min-h-full w-full animate-fade-in flex-1">
          {children}
        </div>
      </div>
      {!isMobile && <IntercomChat />}
    </div>
  );
};
